import { useMemo } from 'react';
import { type ISecodaEntity } from '../../api';
import { FilterOptionType } from '../../components/Filter';
import type { ExtendedDataTableColumn } from '../../components/TableV2/types';
import { useColumns as useCatalogColumns } from '../TeamCatalogPage/TeamCatalogPage.hooks';
import { TrashTitleRender } from './TrashTitleRender';

export const useColumns = (): ExtendedDataTableColumn<ISecodaEntity>[] => {
	const catalogColumns = useCatalogColumns();

	const columns: ExtendedDataTableColumn<ISecodaEntity>[] = useMemo(() => {
		const otherColumns = catalogColumns.filter(
			(column) => !['title'].includes(column.accessor)
		);
		return [
			{
				accessor: 'title',
				titleLabel: 'Title',
				render: (record) => <TrashTitleRender record={record} />,
				filterOptionType: FilterOptionType.TITLE,
			},
			...otherColumns,
		];
	}, [catalogColumns]);

	return columns;
};
